import {
    useCreateDialogChip,
    useCreateDialogRequest,
    useCreateRoute,
} from 'components/create-dialog/CreateDialogContext';
import Loader from 'components/Loader';
import { useEffect, useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { useGetMarketingProfileByIdQuery } from 'store/api/marketingProfiles';
import { MarketingProfileCreateUpdateRequest } from 'types/marketingProfiles';
import MarketingProfileDetailsPage from './MarketingProfileDetailsPage';

const MarketingProfileDuplicatePage = (): JSX.Element => {
    const { id } = useCreateRoute().params;
    const closeDialog = useCreateDialogRequest()?.close;
    const numericId = Number(id);
    const { data: profile, isError } = useGetMarketingProfileByIdQuery(numericId, {
        skip: !id || Number.isNaN(numericId),
    });

    const initialValue = useMemo<MarketingProfileCreateUpdateRequest | undefined>(
        () =>
            profile
                ? {
                      name: profile.name ?? '',
                      filterCriteria: profile.filterCriteria,
                  }
                : undefined,
        [profile]
    );

    useCreateDialogChip({ copyOf: profile?.name });

    // A redirect would move the page behind the create dialog: with no source to copy, the dialog closes instead.
    useEffect(() => {
        if (isError) {
            closeDialog?.();
        }
    }, [isError, closeDialog]);

    if (isError && !closeDialog) {
        return <Navigate to="/contacts/marketing" replace />;
    }

    if (initialValue === undefined) {
        return <Loader />;
    }

    return <MarketingProfileDetailsPage initialValue={initialValue} forceCreateMode />;
};

export default MarketingProfileDuplicatePage;
